<template src="./index.html"></template>

<script>
import { inQueryDetail, inQueryDetailInfo } from '../../../../api/home.js';
import { getdata } from './data.js';
import config from '../../../../../configHttp';
export default {
	name: 'SubLedgerTable',
	data() {
		return {
			pagination: getdata().pagination,
			headData: getdata().headData,
			tableData: [],
			tablekey: 0,
			Count: 0,
			/* 表格 */
			sort: '',
			order: '',
			id: '',
			zhongfkm: '',
			cain: '',
			qij: '',
			//统计
			Countlist: [],
			infoData: {
				initialAmount: '', //期初余额，
				companyAccount: {
					accountCode: '',
					accountDesc: ''
				},
				sumBorrowAmountByMonth: '',
				sumLoanAmountByMonth: '',
				sumBorrowAmountByYear: '',
				sumLoanAmountByYear: ''
			}
		};
	},
	mounted() {},
	activated() {},
	created() {
		this.id = this.$route.query.id;
		this.zhongfkm = this.$route.query.zhongfkm;
		this.cain = this.$route.query.cain;
		this.qij = this.$route.query.qij;
		this.initTableInfo();
		this.initTableDetail();
	},
	methods: {
		//查询
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.initTableDetail();
			this.initTableInfo();
		},
		//下载明细账PDF
		PDFDownload(){
			let params = {};
			params.cain = this.cain;
			params.qij = this.qij;
			params.qijEnd = this.qij;
			params.baoblx = ["0"];
			params.zhongfkmStart = this.zhongfkm;
			params.zhongfkmEnd = this.zhongfkm;
			let req = {
				downUrl: config.baseURL + '/fvm/voucher/detailPDFDownload',
				params: params,
				typeObj: {
					toForm: false,
					fileType: 'pdf',
					fileName: this.zhongfkm + "-" + this.cain + this.qij
				}
			};
			this.$downloadcommon(req);
		},
		//表格字段排序
		sortchange(e) {
			
		},
		//显示条数
		sizechange(e) {
			this.pagination.pageSize = e;
			this.initTableDetail();
		},
		//显示页码
		currentChange(e) {
			this.pagination.pageNum = e;
			this.initTableDetail();
		},

		initTableInfo() {
			let query = { zhongfkm: this.zhongfkm, cain: this.cain, qij: this.qij };
			//加载表格外部数据
			inQueryDetailInfo(query).then(res => {
				let body = res.data;
				if ((body.code = 200)) {
					this.infoData = body.data;
					//统计数据
					this.Countlist = [
						{
							label: '本期借方合计',
							value: this.$toThousands(this.infoData.sumBorrowAmountByMonth)
						},
						{
							label: '本期贷方合计',
							value: this.$toThousands(this.infoData.sumLoanAmountByMonth)
						},
						{
							label: '本年累计借方',
							value: this.$toThousands(this.infoData.sumBorrowAmountByYear)
						},
						{
							label: '本年累计贷方',
							value:this.$toThousands(this.infoData.sumLoanAmountByYear) 
						},
						{
							label: '本期期末余额',
							value:this.$toThousands(this.infoData.yue) 
						}
					];
				}
			});
		},
		initTableDetail() {
			//加载表格数据
			let params = {};
			let query = { zhongfkm: this.zhongfkm, cain: this.cain, qij: this.qij };
			params.criteriaJson = JSON.stringify(query);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = this.sort;
			params.order = this.order;
			inQueryDetail(params).then(res => {
				this.tableData = res.data.data.map(v => {
					v.pingzrq = this.formatDateToDay(v.pingzrq);
					return v;
				});
				this.pagination.total = res.data.count;
			});
		},
		// 跳转到凭证预览
		toPinzyl(value) {
			this.$router.push({
				path: '/PreviewVoucher',
				query: {
					id: value
				}
			});
		},
		// 时间戳转换日期格式方法
		formatDateToDay(value) {
			if (value == null) {
				return value;
			} else {
				const date = new Date(value);
				const y = date.getFullYear(); // 年
				let MM = date.getMonth() + 1; // 月
				MM = MM < 10 ? '0' + MM : MM;
				let d = date.getDate(); // 日
				d = d < 10 ? '0' + d : d;
				// return y + '-' + MM + '-' + d;
				return d;
			}
		},
		forback() {
			this.$router.push({
				path: '/GLView',
				query: {
					id: this.id,
					zhongfkm: this.zhongfkm,
					cain: this.cain
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
